import Vue from 'vue';
import VueI18n from 'vue-i18n';

import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';

import enLocale from './en/index';
import zhLocale from './zh/index';

Vue.use(VueI18n);

const ENGLISH_LANGUAGE = 'en-us';
const ENGLISH_LOCALE = 'en';
const DEFAULT_LOCALE = 'zh-cn';

const messages = {
  'en': {
    ...enLocale,
    ...elementEnLocale,
  },
  'zh-cn': {
    ...zhLocale,
    ...elementZhLocale,
  },
};

export const resolveLocale = (language?: string | null) => {
  return typeof language === 'string' && language.toLowerCase() === ENGLISH_LANGUAGE
    ? ENGLISH_LOCALE
    : DEFAULT_LOCALE;
};

export const getLocale = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE;
  }
  const match = window.location.search.match(/[?&]language=([^&]+)/i);
  return resolveLocale(match ? decodeURIComponent(match[1]) : '');
};

const i18n = new VueI18n({
  locale: getLocale(),
  messages,
});

export const syncLocale = (language?: string | null) => {
  i18n.locale = resolveLocale(language);
};

export default i18n;
